import React from "react";
import { Link } from "react-router-dom";

import StudentItem from "./StudentItem";
import { HoverableTable } from "../../components/UIElements/HoverableTable";
import { Button, Tbody, Th, Thead, Tr } from "@chakra-ui/react";

import "./StudentList.css"
import { SHARED_ROUTES } from "../../config/routes";

const StudentList = ({ students, shouldOmitSource, shouldOmitWeekDetails, date, locationID }) => {
  if (!students || !students.length) return null;

  return (
    <>
      <HoverableTable size="sm" whiteSpace="normal" className="student-list" mb="1.5em" backgroundColor="white">
        <Thead>
          <Tr fontSize="0.9em" textTransform="capitalize">
            <Th>Student</Th>
            <Th>School Name</Th>
            <Th>Gender</Th>
            {!shouldOmitWeekDetails && <Th>Start Date</Th>}
            {!shouldOmitWeekDetails && <Th>Location</Th>}
            <Th>Guardian</Th>
            <Th>Medical Conditions</Th>
            <Th maxWidth="70px">Leave During Lunch</Th>
            <Th maxWidth="80px">Consent Granted</Th>
            <Th maxWidth="80px">Consent For Photo</Th>
            {!shouldOmitSource && <Th>Info Source</Th>}
          </Tr>
        </Thead>
        <Tbody>
          {students.map((student) => (
            <StudentItem
              key={student.student_id}
              id={student.student_id}
              name={student.student_name}
              email={student.email_address}
              school={student.school_id}
              booking={student.preferred_location_id}
              gender={student.gender_id}
              gender_name={student.gender_name}
              school_name={student.school_name}
              week={student.week_starting_date}
              office={student.location_name}
              reconfirm_status={student.reconfirm_status}
              guardian_name={student.guardian_name}
              emergency_contact_number={student.emergency_contact_number}
              medical_conditions={student.medical_conditions}
              is_allowed_leave_during_lunch={student.is_allowed_leave_during_lunch}
              ty_info_source={student.ty_info_source}
              is_consent_granted={student.is_consent_granted}
              is_allowed_photo_during_training={student.is_allowed_photo_during_training}
              shouldOmitSource={shouldOmitSource}
              shouldOmitWeekDetails={shouldOmitWeekDetails}
            />
          ))}
        </Tbody>
      </HoverableTable>

      <Link to={`${SHARED_ROUTES.createStudent}?weekStartingDate=${date}&locationId=${locationID}`} className="student-button">
        <Button as="span" colorScheme="red">
          Add Student
        </Button>
      </Link>
    </>
  );
};

export default StudentList;
